import { useEffect } from "react";

export const useGoogleAdTargeting = (
  attributes: Record<string, string | undefined | null> = {}
) => {
  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd.push(() => {
      Object.entries(attributes).forEach(([name, value]) => {
        if (value) {
          window.googletag.pubads().setTargeting(name, value);
        }
      });
    });
  }, [JSON.stringify(attributes)]);
};
